/**
 * Display names for user roles (shown in Navbar, dropdowns, etc.)
 */
import { BIDDER_ROLE, isRoleDisabled } from "constants/authRoles";

export const ROLE_DISPLAY_NAMES = {
  [BIDDER_ROLE]: "Bidder",
  lead: "Bidder Team Lead",
  admin: "Admin",
  superadmin: "Superadmin",
  caller: "Caller",
  assistant: "Operations Assistant",
};

export function getRoleDisplayName(role, options = {}) {
  if (!role) return "Unknown Role";
  if (role === "caller" && options.callerTeamLead) return "Caller Team Lead";
  if (isRoleDisabled(role)) {
    return `${ROLE_DISPLAY_NAMES[role] || role} — deactivated`;
  }
  return ROLE_DISPLAY_NAMES[role] || role;
}
